import axios from "@/api/axios";

async function saveMeasurements(jsonObj, isUpper) {
  if (!jsonObj) return false;
  let retval = false;
  try {
    console.log("saveMeasurements request");
    let url = "/api/intraoral/saveMeasurements";
    let formData = new FormData();
    let blob = new Blob([JSON.stringify(jsonObj)], {
      type: "text/plain",
    });

    formData.append(
      "file",
      blob,
      isUpper
        ? "saved_upper_measurements.json"
        : "saved_lower_measurements.json",
    );
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    formData.append("isStaging", !!vueApp.isStaging);

    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    };

    const response = await axios.post(url, formData, config);
    retval = response.status == 200;
    console.log("saveMeasurements", response);
  } catch (error) {
    console.error("saveMeasurements", error);
  }
  return retval;
}

async function sendSaveIntraoralDataRequest(
  blob,
  isDouble,
  hasStubs,
  callback,
) {
  console.log("sendSaveIntraoralDataRequest");
  let responseBlob = null;

  try {
    let url = "/api/intraoral/saveData";
    let formData = new FormData();
    formData.append("file", blob, `intraoral_data_${vueApp.patientId}.zip`);
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    formData.append("isDouble", !!isDouble);
    formData.append("hasStubs", !!hasStubs);
    formData.append("isStaging", !!vueApp.isStaging);

    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}
    config.responseType = "arraybuffer";

    const response = await axios.post(url, formData, config);
    responseBlob = response.data;
  } catch (e) {
    console.log("sendSaveIntraoralDataRequest error", e);
  }

  if (callback) {
    callback(responseBlob);
  }
}

async function checkPatientInPostprocess(patientId) {
  try {
    let url = `/api/intraoral/checkPatientInPostprocess?patientId=${patientId}&isStaging=${!!vueApp.isStaging}`;
    const response = await axios.get(url, patientId);
    const responseData = response.data;
    console.log("checkPatientInPostprocess responseData", responseData);
    return responseData.value;
  } catch (e) {
    // console.log("checkPatientInPostprocess error", e);
    return false;
  }
}

async function sendCreateStubsRequest(callback) {
  console.log("sendCreateStubsRequest");
  let responseData = null;

  try {
    let url = "/api/intraoral/createStubs";
    let formData = new FormData();
    formData.append("patientId", vueApp.patientId);
    formData.append("isStaging", !!vueApp.isStaging);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}

    const response = await axios.post(url, formData, config);
    console.log("sendCreateStubsRequest response", response);

    responseData = response.data;
  } catch (e) {
    console.log("sendCreateStubsRequest error", e);
  }

  if (callback) {
    callback(responseData);
  }
}

async function sendCreateMeasurementsRequest(callback) {
  console.log("sendCreateMeasurementsRequest");
  let responseData = null;

  try {
    let url = "/api/intraoral/createMeasurements";
    let formData = new FormData();
    formData.append("patientId", vueApp.patientId);
    formData.append("isStaging", !!vueApp.isStaging);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}

    const response = await axios.post(url, formData, config);
    console.log("sendCreateMeasurementsRequest response", response);

    responseData = response.data;
  } catch (e) {
    console.log("sendCreateMeasurementsRequest error", e);
  }

  if (callback) {
    callback(responseData);
  }
}

async function checkBracesTaskInProgress(patientId) {
  try {
    let url = `/api/intraoral/checkBracesTaskInProgress?patientId=${patientId}&isStaging=${!!vueApp.isStaging}`;
    const response = await axios.get(url, patientId);
    const responseData = response.data;
    console.log("checkBracesTaskInProgress responseData", responseData);
    return responseData.value;
  } catch (e) {
    console.log("checkBracesTaskInProgress error", e);
    return false;
  }
}

async function sendRemoveBracesRequest(callback) {
  console.log("sendRemoveBracesRequest");
  let responseData = null;

  try {
    let url = "/api/intraoral/removeBraces";
    let formData = new FormData();
    formData.append("patientId", vueApp.patientId);
    formData.append("isStaging", !!vueApp.isStaging);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}

    const response = await axios.post(url, formData, config);
    console.log("sendRemoveBracesRequest response", response);

    responseData = response.data;
  } catch (e) {
    console.log("sendRemoveBracesRequest error", e);
  }

  if (callback) {
    callback(responseData);
  }
}

async function sendApplyAnchorPointsRequest(blob, isDouble, isUpper, callback) {
  let responseBlob = null;
  if (callback) {
    callback(responseBlob);
  }
}

async function sendApplyBorderPointsRequest(blob, isDouble, isUpper, callback) {
  let responseBlob = null;
  try {
    let url = "/api/intraoral/applyBorderPoints";
    let formData = new FormData();
    formData.append("file", blob, `points.json`);
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    formData.append("isDouble", !!isDouble);
    formData.append("isUpper", !!isUpper);
    formData.append("isStaging", !!vueApp.isStaging);
    // formData.append("toothNumber", toothNumber ? +toothNumber : 0);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}
    config.responseType = "arraybuffer";

    const response = await axios.post(url, formData, config);
    responseBlob = response.data;
  } catch (e) {
    console.log("sendApplyBorderPointsRequest error", e);
  }
  if (callback) {
    callback(responseBlob);
  }
}

async function sendSavePanoJsonRequest(jsonObj) {
  if (!jsonObj) return false;
  let retval = false;
  try {
    console.log("sendSavePanoJsonRequest");
    let url = "/api/intraoral/savePanoJson";
    let formData = new FormData();
    let blob = new Blob([JSON.stringify(jsonObj)], {
      type: "text/plain",
    });
    formData.append("file", blob, "panoramic-overlay.json");
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    };

    const response = await axios.post(url, formData, config);
    retval = response.status == 200;
    console.log("sendSavePanoJson response", response);
  } catch (error) {
    console.error("sendSavePanoJson error", error);
  }
  return retval;
}

export {
  checkPatientInPostprocess,
  checkBracesTaskInProgress,
  sendSaveIntraoralDataRequest,
  sendApplyAnchorPointsRequest,
  sendApplyBorderPointsRequest,
  sendCreateStubsRequest,
  sendCreateMeasurementsRequest,
  sendRemoveBracesRequest,
  saveMeasurements,
  sendSavePanoJsonRequest,
};
